import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto auto minmax(0px, 1fr) 192px',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '24px',
    cursor: 'pointer',

    '&:hover': {
      background: '#F5F6F8'
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'auto auto minmax(0px, 1fr) auto'
    }
  },

  rootBorder: {
    borderBottom: '1px solid #C6C6C6',

    '&:hover': {
      borderBottomColor: 'transparent'
    }
  },

  checkboxArea: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '24px',
    width: '24px',
    maxWidth: '24px'
  },

  icon: {
    marginRight: '16px'
  },

  bodyArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  bodyNew: {
    '& $title, & $body': {
      color: theme.palette.primary.main
    }
  },

  title: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    wordBreak: 'break-word'
  },

  body: {
    maxWidth: '80%',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    wordBreak: 'break-word'
  },

  rightArea: {
    display: 'flex',
    paddingLeft: '40px',
    height: '100%'
  },

  time: {
    fontSize: theme.size.base,
    textAlign: 'right',
    color: '#8F8F8F'
  },

  markRead: {
    alignSelf: 'center'
  },

  markReadButton: {
    height: '30px',
    width: 'auto'
  }
}))

export default useStyles
